import { render } from "./ApartmentBudgetTable.vue?vue&type=template&id=5193e3d4"
import script from "./ApartmentBudgetTable.vue?vue&type=script&lang=js"
export * from "./ApartmentBudgetTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__